import webMessageModule from '../../services/webMessage';
const moment = require('moment');

export default {
  name: 'webMessageList',
  data() {
    return {
      fetchingData: false,
      webMessageList: [],
      webMessageReportPageRoute: '',

      creatingWebMessage: false,
      createDialogVisible: false,
      webMessageTypeInfo: [
        {
          type: 'popup',
          title: 'Popup',
          description: 'Popups in the middle of the screen.',
          img: 'data:image/svg+xml;base64,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'
        },
        {
          type: 'flyout',
          title: 'Flyout',
          description: 'Slides from side of the screen.',
          img: 'data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTM4cHgiIGhlaWdodD0iODRweCIgdmlld0JveD0iMCAwIDEzOCA4NCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIj4KICAgIDwhLS0gR2VuZXJhdG9yOiBTa2V0Y2ggNDkuMyAoNTExNjcpIC0gaHR0cDovL3d3dy5ib2hlbWlhbmNvZGluZy5jb20vc2tldGNoIC0tPgogICAgPHRpdGxlPmZseW91dF91bnNlbGVjdGVkPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9ImZseW91dF91bnNlbGVjdGVkIiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyBpZD0iR3JvdXAtNyI+CiAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgc3Ryb2tlPSIjOTE5NzlGIiBzdHJva2Utd2lkdGg9IjIiIHg9IjEiIHk9IjEiIHdpZHRoPSIxMzYiIGhlaWdodD0iODIiIHJ4PSIyIj48L3JlY3Q+CiAgICAgICAgICAgIDxnIGlkPSJHcm91cCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNi4wMDAwMDAsIDYuMDAwMDAwKSIgZmlsbD0iI0RGRTNFNiI+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBpZD0iT3ZhbCIgY3g9IjEuOTczNjg0MjEiIGN5PSIyIiByeD0iMS45NzM2ODQyMSIgcnk9IjIiPjwvZWxsaXBzZT4KICAgICAgICAgICAgICAgIDxlbGxpcHNlIGlkPSJPdmFsIiBjeD0iNy41IiBjeT0iMiIgcng9IjEuOTczNjg0MjEiIHJ5PSIyIj48L2VsbGlwc2U+CiAgICAgICAgICAgICAgICA8ZWxsaXBzZSBpZD0iT3ZhbCIgY3g9IjEzLjAyNjMxNTgiIGN5PSIyIiByeD0iMS45NzM2ODQyMSIgcnk9IjIiPjwvZWxsaXBzZT4KICAgICAgICAgICAgPC9nPgogICAgICAgICAgICA8ZyBpZD0iR3JvdXAtNSIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNjcuMDAwMDAwLCA0OC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgc3Ryb2tlPSIjOTE5NzlGIiBzdHJva2Utd2lkdGg9IjIiIHg9IjEiIHk9IjEiIHdpZHRoPSI2OSIgaGVpZ2h0PSIzNCIgcng9IjIiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgZmlsbD0iI0RGRTNFNiIgeD0iMTYiIHk9IjE1IiB3aWR0aD0iNDAiIGhlaWdodD0iNCIgcng9IjEiPjwvcmVjdD4KICAgICAgICAgICAgICAgIDxyZWN0IGlkPSJSZWN0YW5nbGUtNyIgZmlsbD0iI0RGRTNFNiIgeD0iOCIgeT0iNyIgd2lkdGg9IjU1IiBoZWlnaHQ9IjQiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgICAgICAgICA8cmVjdCBpZD0iUmVjdGFuZ2xlLTciIGZpbGw9IiM5MTk3OUYiIHg9IjExIiB5PSIyMyIgd2lkdGg9IjUwIiBoZWlnaHQ9IjYiIHJ4PSIxIj48L3JlY3Q+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg=='
        },
        {
          type: 'embed',
          title: 'Embed',
          description: 'Embedded in your site. This requires adding a small snippet of code to your site where you want the form to appear.',
          img: 'data:image/svg+xml;base64,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'
        }
      ],
      createWebMessageForm: {
        name: '',
        type: 'popup'
      }
    };
  },

  methods: {
    onCreateWebMessageClick() {
      this.creatingWebMessage = true;
    },

    getWebMessageDetailsPageLink(webMessage) {
      if (webMessage.status == 'draft') {
        return '/webMessage/' + webMessage.id + '/edit';
      } else {
        return '/webMessage/' + webMessage.id + '/report';
      }
    },

    fetchWebMessageList() {
      this.fetchingData = true;
      webMessageModule
        .fetchWebMessageList()
        .then((result) => {
          this.webMessageList = result.data;

          for (var i = 0; i < this.webMessageList.length; i++) {
            this.webMessageList[i].created_at = this.webMessageList[i].created_at && this.webMessageList[i].created_at != 'N/A' ? this.getDisplayTime(this.webMessageList[i].created_at) : 'N/A';
            this.webMessageList[i].updated_at = this.webMessageList[i].updated_at && this.webMessageList[i].updated_at != 'N/A' ? this.getDisplayTime(this.webMessageList[i].updated_at) : 'N/A';

            // Creator
            this.creatorName = '';
            if (this.webMessageList[i].creator_first_name) {
              this.creatorName = this.webMessageList[i].creator_first_name + ' ' + this.webMessageList[i].creator_last_name;
            }
            this.webMessageList[i].creator_name = this.creatorName;

            // Updator
            this.updatorName = 'N/A';
            if (this.webMessageList[i].updator_first_name) {
              this.updatorName = this.webMessageList[i].updator_first_name + ' ' + this.webMessageList[i].updator_last_name;
            }
            this.webMessageList[i].updator_name = this.updatorName;
          }

          this.fetchingData = false;
        })
        .catch((e) => {
          this.reportError(e);
          this.errorToast('Something went wrong.');
          this.fetchingData = false;
        });
    },

    getDisplayTime(date) {
      if (!date) {
        return `N/A`;
      }
      var dt = moment(date, 'x');
      return dt.format('DD-MMM-YYYY hh:mm A');
    },

    showCreateDialog() {
      this.createDialogVisible = true;
    },

    async callCreateMessageApi() {
      try {
        // Validate Form.
        if (!this.createWebMessageForm.name) {
          this.warningToast('Name is required.');
          return;
        }

        let result = await webMessageModule.createDraft({
          name: this.createWebMessageForm.name,
          messageType: this.createWebMessageForm.type
        });
        let campaignId = result.data;
        this.$router.push(`/webMessage/${campaignId}/edit`);
      } catch (err) {
        this.reportError(err);
        this.errorToast('Failed to create campaign. Please contact support.');
        this.fetchingData = false;
      }
    }
  },

  mounted() {
    this.fetchWebMessageList();
  }
};
